const INDIVIDUAL_DEPOSIT_ROUBLE = 'rubleDeposits';
const INDIVIDUAL_DEPOSIT = 'deposits';
const INDIVIDUAL_DEPOSIT_CURRENCY = 'currencyDeposits';
const BUSINESS_CLIENT_BANK = 'businessClientBank';
const BUSINESS_SALARY_PROJECT = 'salaryProjects';
const FOR_MEDICAL_PROFS = 'medicalProfessionals';
const BUSINESS_LOAN = 'businessCrediting';
const BUSINESS_SELF_EMPLOYED = 'businessSelfEmployed';
const BUSINESS_LOAN_WOMAN = 'womensBusinessCrediting';
const BUSINESS_LOAN_ONLINE = 'onlineBusinessCrediting';
const BUSINESS_LOAN_DIGITAL_TRANSFORM = 'digitalTransformBusinessCrediting';
const BUSINESS_LOAN_ADV_OVERDRAFT = 'advanceOverdraftBusinessCrediting';
const BUSINESS_LOAN_STARTUP = 'startupBusinessCrediting';
const BUSINESS_LOAN_SOCIAL_RESPONSIBILITY = 'socialResponsibilityBusinessCrediting';
const BUSINESS_LOAN_TRANSFORM = 'transformBusinessCrediting';
const BUSINESS_LOAN_SEASONAL_OFFER = 'seasonalOfferBusinessCrediting';
const BUSINESS_LOAN_APK = 'apkBusinessCrediting';
const BUSINESS_LOAN_MSB = 'smallBusinessCrediting';
const BUSINESS_LOAN_OVERDRAFT = 'overdraftBusinessCrediting';
const BUSINESS_LOAN_COMMERCIAL_MORTGAGE = 'commercialMortgageBusinessCrediting';
const BUSINESS_LOAN_SMALL_AUTO = 'autoForSmallBusinessCrediting';
const BUSINESS_LOAN_ENERGY_EFFICIENT_INVEST = 'energyEfficientInvestmentBusinessCrediting';
const BUSINESS_LOAN_REPLENISH_CAPITAL = 'replenishCapitalBusinessCrediting';
const BUSINESS_LOAN_AGRICULTURAL_MACHINERY = 'agriculturalMachineryBusinessCrediting';
const BUSINESS_LOAN_TSJ = 'tsjBusinessCrediting';
const BUSINESS_LOAN_BANK_GUARANTEES = 'bankGuaranteesBusinessCrediting';
const BUSINESS_LOAN_LEASING = 'leasingBusinessCrediting';
const BUSINESS_LOAN_BUILDING_CONSTRUCTION = 'buildingConstructionBusinessCrediting';
const BUSINESS_LOAN_CONTRACT = 'contractBusinessCrediting';
const CAREER = 'career';
const CREDIT_MARKETPLACE = 'creditMarketplace';
const OBOROT_BUSINESS_CREDITING = 'pskOborotBusinessCrediting';
const INVEST_BUSINESS_CREDITING = 'pskInvestBusinessCrediting';
const BUSINESS_GREEN_MORTGAGE = 'businessGreenMortgage';
const BUSINESS_DEPOSITS = 'businessDeposits';

const INDIVIDUAL_DEPOSIT_ROUBLE_PATH = '/for-individuals/deposits/ruble-deposits';
const INDIVIDUAL_DEPOSIT_PATH = '/for-individuals/deposits';
const INDIVIDUAL_DEPOSIT_CURRENCY_PATH = '/for-individuals/deposits/currency-deposits';
const BUSINESS_CLIENT_BANK_PATH = '/business/client-bank';
const BUSINESS_SALARY_PROJECT_PATH = '/business/salary-projects';
const FOR_MEDICAL_PROFS_PATH = '/social-projects/medical-professionals';
const BUSINESS_LOAN_PATH = '/business/business-crediting';
const BUSINESS_LOAN_WOMAN_PATH = '/business/business-crediting/biznes-kredit-dlia-zhenshchin';
const BUSINESS_LOAN_ONLINE_PATH = '/business/business-crediting/onlain-kredit';
const BUSINESS_LOAN_DIGITAL_TRANSFORM_PATH = '/business/business-crediting/tsifrovaia-transformatsiia-dlia-biznesa';
const BUSINESS_LOAN_ADV_OVERDRAFT_PATH = '/business/business-crediting/avansovyi-oferdraft';
const BUSINESS_LOAN_STARTUP_PATH = '/business/business-crediting/startap';
const BUSINESS_LOAN_SOCIAL_RESPONSIBILITY_PATH = '/business/business-crediting/sotsialnaia-otvetstvennost';
const BUSINESS_LOAN_TRANSFORM_PATH = '/business/business-crediting/transformatsiia-biznesa';
const BUSINESS_LOAN_SEASONAL_OFFER_PATH = '/business/business-crediting/sezonnoe-kreditnoe-predlozhenie';
const BUSINESS_LOAN_APK_PATH = '/business/business-crediting/lgotnye-kredity-apk';
const BUSINESS_LOAN_MSB_PATH = '/business/business-crediting/lgotnyi-kredit-dlia-malogo-i-srednego-biznesa';
const BUSINESS_LOAN_OVERDRAFT_PATH = '/business/business-crediting/overdraft';
const BUSINESS_LOAN_COMMERCIAL_MORTGAGE_PATH = '/business/business-crediting/kommercheskaia-ipoteka';
const BUSINESS_LOAN_SMALL_AUTO_PATH = '/business/business-crediting/avtomobilnyi-dlia-malogo-biznesa';
const BUSINESS_LOAN_ENERGY_EFFICIENT_INVEST_PATH
= '/business/business-crediting/investitsionnyi-kredit-dlia-modernizatsii-energoeffektivnykh-tekhnologii';
const BUSINESS_LOAN_REPLENISH_CAPITAL_PATH = '/business/business-crediting/na-popolnenie-oborotnykh-sredstv';
const BUSINESS_LOAN_AGRICULTURAL_MACHINERY_PATH = '/business/business-crediting/na-priobretenie-selkhoztekhniki';
const BUSINESS_LOAN_TSJ_PATH = '/business/business-crediting/kreditovanie-tszh-i-uk';
const BUSINESS_LOAN_BANK_GUARANTEES_PATH = '/business/business-crediting/bankovskie-garantii';
const BUSINESS_LOAN_LEASING_PATH = '/business/business-crediting/lizing';
const BUSINESS_LOAN_BUILDING_CONSTRUCTION_PATH
= '/business/business-crediting/na-stroitelstvo-mnogokvartirnogo-doma-s-ispolzovaniem-eskrou-schetov';
const BUSINESS_LOAN_CONTRACT_PATH = '/business/business-crediting/kredit-pod-kontrakt';
const CAREER_PATH = '/social-projects/career';
const CREDIT_MARKETPLACE_PATH = '/for-individuals/crediting/consumer-loan/credit-marketplace';
const OBOROT_BUSINESS_CREDITING_PATH = '/business/business-crediting/psk-oborotnaia';
const INVEST_BUSINESS_CREDITING_PATH = '/business/business-crediting/psk-investitsionnaia';
const BUSINESS_GREEN_MORTGAGE_PATH = '/business/business-crediting/zelenaia-ipoteka-dlia-biznesa';
const BUSINESS_DEPOSITS_PATH = '/business/placement-of-funds-and-securities';
const BUSINESS_DEPOSIT_CLASSIC_PATH = '/business/placement-of-funds-and-securities/classic';
const BUSINESS_DEPOSIT_URGENT_PATH = '/business/placement-of-funds-and-securities/urgent';
const BUSINESS_DEPOSIT_COMFORT_PATH = '/business/placement-of-funds-and-securities/comfort';
const BUSINESS_DEPOSIT_MINIMUM_BALANCE_PATH = '/business/placement-of-funds-and-securities/minimumBalance';
const BUSINESS_SELF_EMPLOYED_PATH = '/business/self-employed';

export default {
    INDIVIDUAL_DEPOSIT_ROUBLE,
    INDIVIDUAL_DEPOSIT,
    INDIVIDUAL_DEPOSIT_CURRENCY,
    BUSINESS_CLIENT_BANK,
    BUSINESS_SALARY_PROJECT,
    FOR_MEDICAL_PROFS,
    BUSINESS_LOAN,
    BUSINESS_LOAN_WOMAN,
    BUSINESS_SELF_EMPLOYED,
    BUSINESS_LOAN_ONLINE,
    BUSINESS_LOAN_DIGITAL_TRANSFORM,
    BUSINESS_LOAN_ADV_OVERDRAFT,
    BUSINESS_LOAN_STARTUP,
    BUSINESS_LOAN_SOCIAL_RESPONSIBILITY,
    BUSINESS_LOAN_TRANSFORM,
    BUSINESS_LOAN_SEASONAL_OFFER,
    BUSINESS_LOAN_APK,
    BUSINESS_LOAN_MSB,
    BUSINESS_LOAN_OVERDRAFT,
    BUSINESS_LOAN_COMMERCIAL_MORTGAGE,
    BUSINESS_LOAN_SMALL_AUTO,
    BUSINESS_LOAN_ENERGY_EFFICIENT_INVEST,
    BUSINESS_LOAN_REPLENISH_CAPITAL,
    BUSINESS_LOAN_AGRICULTURAL_MACHINERY,
    BUSINESS_LOAN_TSJ,
    BUSINESS_LOAN_BANK_GUARANTEES,
    BUSINESS_LOAN_LEASING,
    BUSINESS_LOAN_BUILDING_CONSTRUCTION,
    BUSINESS_LOAN_CONTRACT,
    CAREER,
    CREDIT_MARKETPLACE,
    OBOROT_BUSINESS_CREDITING,
    INVEST_BUSINESS_CREDITING,
    BUSINESS_GREEN_MORTGAGE,
    BUSINESS_DEPOSITS,
};

export const PATH_SCHEME = [
    {
        id: INDIVIDUAL_DEPOSIT_ROUBLE,
        path: INDIVIDUAL_DEPOSIT_ROUBLE_PATH,
    },
    {
        id: INDIVIDUAL_DEPOSIT,
        path: INDIVIDUAL_DEPOSIT_PATH,
    },
    {
        id: INDIVIDUAL_DEPOSIT_CURRENCY,
        path: INDIVIDUAL_DEPOSIT_CURRENCY_PATH,
    },
    {
        id: BUSINESS_CLIENT_BANK,
        path: BUSINESS_CLIENT_BANK_PATH,
    },
    {
        id: BUSINESS_SALARY_PROJECT,
        path: BUSINESS_SALARY_PROJECT_PATH,
    },
    {
        id: FOR_MEDICAL_PROFS,
        path: FOR_MEDICAL_PROFS_PATH,
    },
    {
        id: BUSINESS_LOAN,
        path: BUSINESS_LOAN_PATH,
    },
    {
        id: BUSINESS_LOAN_WOMAN,
        path: BUSINESS_LOAN_WOMAN_PATH,
    },
    {
        id: BUSINESS_LOAN_ONLINE,
        path: BUSINESS_LOAN_ONLINE_PATH,
    },
    {
        id: BUSINESS_LOAN_DIGITAL_TRANSFORM,
        path: BUSINESS_LOAN_DIGITAL_TRANSFORM_PATH,
    },
    {
        id: BUSINESS_LOAN_ADV_OVERDRAFT,
        path: BUSINESS_LOAN_ADV_OVERDRAFT_PATH,
    },
    {
        id: BUSINESS_LOAN_STARTUP,
        path: BUSINESS_LOAN_STARTUP_PATH,
    },
    {
        id: BUSINESS_LOAN_SOCIAL_RESPONSIBILITY,
        path: BUSINESS_LOAN_SOCIAL_RESPONSIBILITY_PATH,
    },
    {
        id: BUSINESS_LOAN_TRANSFORM,
        path: BUSINESS_LOAN_TRANSFORM_PATH,
    },
    {
        id: BUSINESS_LOAN_SEASONAL_OFFER,
        path: BUSINESS_LOAN_SEASONAL_OFFER_PATH,
    },
    {
        id: BUSINESS_LOAN_APK,
        path: BUSINESS_LOAN_APK_PATH,
    },
    {
        id: BUSINESS_LOAN_MSB,
        path: BUSINESS_LOAN_MSB_PATH,
    },
    {
        id: BUSINESS_LOAN_OVERDRAFT,
        path: BUSINESS_LOAN_OVERDRAFT_PATH,
    },
    {
        id: BUSINESS_LOAN_COMMERCIAL_MORTGAGE,
        path: BUSINESS_LOAN_COMMERCIAL_MORTGAGE_PATH,
    },
    {
        id: BUSINESS_LOAN_SMALL_AUTO,
        path: BUSINESS_LOAN_SMALL_AUTO_PATH,
    },
    {
        id: BUSINESS_LOAN_ENERGY_EFFICIENT_INVEST,
        path: BUSINESS_LOAN_ENERGY_EFFICIENT_INVEST_PATH,
    },
    {
        id: BUSINESS_LOAN_REPLENISH_CAPITAL,
        path: BUSINESS_LOAN_REPLENISH_CAPITAL_PATH,
    },
    {
        id: BUSINESS_LOAN_AGRICULTURAL_MACHINERY,
        path: BUSINESS_LOAN_AGRICULTURAL_MACHINERY_PATH,
    },
    {
        id: BUSINESS_LOAN_TSJ,
        path: BUSINESS_LOAN_TSJ_PATH,
    },
    {
        id: BUSINESS_LOAN_BANK_GUARANTEES,
        path: BUSINESS_LOAN_BANK_GUARANTEES_PATH,
    },
    {
        id: BUSINESS_LOAN_LEASING,
        path: BUSINESS_LOAN_LEASING_PATH,
    },
    {
        id: BUSINESS_LOAN_BUILDING_CONSTRUCTION,
        path: BUSINESS_LOAN_BUILDING_CONSTRUCTION_PATH,
    },
    {
        id: BUSINESS_LOAN_CONTRACT,
        path: BUSINESS_LOAN_CONTRACT_PATH,
    },
    {
        id: CAREER,
        path: CAREER_PATH,
    },
    {
        id: CREDIT_MARKETPLACE,
        path: CREDIT_MARKETPLACE_PATH,
    },
    {
        id: OBOROT_BUSINESS_CREDITING,
        path: OBOROT_BUSINESS_CREDITING_PATH,
    },
    {
        id: INVEST_BUSINESS_CREDITING,
        path: INVEST_BUSINESS_CREDITING_PATH,
    },
    {
        id: BUSINESS_GREEN_MORTGAGE,
        path: BUSINESS_GREEN_MORTGAGE_PATH,
    },
    {
        id: BUSINESS_DEPOSITS,
        path: BUSINESS_DEPOSITS_PATH,
    },
    {
        id: BUSINESS_DEPOSITS,
        path: BUSINESS_DEPOSIT_CLASSIC_PATH,
    },
    {
        id: BUSINESS_DEPOSITS,
        path: BUSINESS_DEPOSIT_URGENT_PATH,
    },
    {
        id: BUSINESS_DEPOSITS,
        path: BUSINESS_DEPOSIT_COMFORT_PATH,
    },
    {
        id: BUSINESS_DEPOSITS,
        path: BUSINESS_DEPOSIT_MINIMUM_BALANCE_PATH,
    },
    {
        id: BUSINESS_SELF_EMPLOYED,
        path: BUSINESS_SELF_EMPLOYED_PATH,
    },
];
